import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ChangeUserPasswordScreen from '../screens/MyProfile/ChangeUserPassword/ChangeUserPasswordScreen';
import ConfirmDeleteAccount from '../screens/MyProfile/Delete/MyProfileScreen_ConfirmDeleteAccount';
import ConfirmDeleteEvent from '../screens/MyProfile/Delete/MyProfileScreen_ConfirmDeleteEvent';
import Delete from '../screens/MyProfile/Delete/MyProfileScreen_Delete';
import DeleteCommunities from '../screens/MyProfile/Delete/MyProfileScreen_DeleteCommunities';
import DeleteEvents from '../screens/MyProfile/Delete/MyProfileScreen_DeleteEvents';
import MyProfileScreen from '../screens/MyProfile/MyProfileScreen';
import Edit from '../screens/MyProfile/MyProfileScreen_Edit';
import Email from '../screens/MyProfile/MyProfileScreen_Email';
import Language from '../screens/MyProfile/MyProfileScreen_Language';
import Photo from '../screens/MyProfile/MyProfileScreen_Photo';
import Privacy from '../screens/MyProfile/MyProfileScreen_Privacy';

const deleteRoutes = ({match}) => (
    <Switch>
        <Route path={`${match.path}/event`} exact component={DeleteEvents} />
        <Route path={`${match.path}/event/:eventId`} exact component={ConfirmDeleteEvent} />
        <Route path={`${match.path}/community`} exact component={DeleteCommunities} />
        <Route path={`${match.path}/community/:eventId`} exact component={ConfirmDeleteEvent} />
        <Route path={`${match.path}/networkapp`} exact component={ConfirmDeleteAccount} />
        <Route component={Delete} />
    </Switch>
);

export default ({match}) => (
    <Switch>
        <Route path={`${match.path}/photo`} exact component={Photo} />
        <Route path={`${match.path}/privacy`} exact component={Privacy} />
        <Route path={`${match.path}/edit`} exact component={Edit} />
        <Route path={`${match.path}/password`} exact component={ChangeUserPasswordScreen} />
        <Route path={`${match.path}/language`} exact component={Language} />
        <Route path={`${match.path}/email`} exact component={Email} />
        <Route path={`${match.path}/delete`} component={deleteRoutes} />
        <Route component={MyProfileScreen} />
    </Switch>
);
